<template>
  <div class="footer">
    <div class="left">
      <span class="gname">滨州市专利技术转移转化服务平台</span>
      <span>电话：{{ websetinfo.phone }}</span>
      <span>邮箱：{{ websetinfo.email }}</span>
      <span>技术支持：{{ websetinfo.support }}</span>
      <span>版权所有：{{ websetinfo.copyright }}</span>
      <span>{{ websetinfo.icp }} {{ websetinfo.identity }}</span>
    </div>
    <div class="right">
      <div class="rleft">
        <span class="rname">关于我们</span>
        <span>平台介绍</span>
        <span>联系我们</span>
      </div>
      <div class="rright">
        <img src="../assets//gcodeimg.png" alt="" />
        <span>官方微信</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {},
  data() {
    return {
      websetinfo: {
        phone: "",
        email: "",
        support: "",
        copyright: "",
        icp: "",
        identity: ""
      }
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getwebset();
  },
  watch: {},
  methods: {
    getwebset() {
      this.$api.get({
        url: "index/setting",
        success: (res) => {
          this.websetinfo.phone = res.data.name.value;
          this.websetinfo.email = res.data.email.value;
          this.websetinfo.support = res.data.support.value;
          this.websetinfo.copyright = res.data.copyright.value;
          this.websetinfo.icp = res.data.icp.value;
          this.websetinfo.identity = res.data.identity.value;
        }
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@media all and (max-width: 1200px) {
  .footer {
    flex-direction: column !important;
    height: auto !important;
    padding-top: 20px;
    .left {
      height: 160px !important;
      .gname {
        font-size: 16px !important;
      }
      span {
        font-size: 12px !important;
      }
    }
    .right {
      margin-top: 40px;
      height: 160px !important;
      .rleft {
        font-size: 12px !important;
        .rname {
          font-size: 18px !important;
        }
      }
      .rright {
        font-style: 16px !important;
      }
    }
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 240px;
  background: #232830;
  position: absolute;
  left: 0;
  // bottom: 0;
  z-index: 99999999999999999999999999;
  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 200px;
    .gname {
      font-size: 20px;
      margin-bottom: 20px;
    }
    span {
      font-size: 13px;
      margin-bottom: 10px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    .rleft {
      display: flex;
      flex-direction: column;
      justify-content: center;

      align-items: center;
      height: 100%;
      margin-right: 40px;
      .rname {
        font-size: 20px;
        margin-bottom: 20px;
      }
      span {
        font-size: 14px;
        margin-bottom: 20px;
      }
    }
    .rright {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      align-items: center;
      img {
        width: 100px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
